export default __webpack_public_path__ + "static/media/logo_cmo.321a6e72.png";